export default function PublicRules({ rules, loading, error, onRetry }) {
	if (loading) {
		return <div className="fairplay-rules-loading">Regeln werden geladen...</div>;
	}

	if (error) {
		return (
			<div className="fairplay-rules-notice fairplay-rules-notice--error">
				<p>{error}</p>
				<button className="button" onClick={onRetry}>
					Erneut versuchen
				</button>
			</div>
		);
	}

	if (rules.length === 0) {
		return (
			<section className="fairplay-rules-section">
				<div className="fairplay-rules-empty">Noch keine Regeln vorhanden.</div>
			</section>
		);
	}

	return (
		<section className="fairplay-rules-section">
			<ul className="fairplay-rules-list">
				{rules.map((rule) => (
					<li key={rule.id} className="fairplay-rules-list__item">
						{rule.icon && (
							<img className="fairplay-rules-icon" src={rule.icon} alt="" />
						)}
						<div>
							<h3 className="fairplay-rules-list__name">{rule.name}</h3>
							{rule.description && (
								<p className="fairplay-rules-list__description">
									{rule.description}
								</p>
							)}
						</div>
					</li>
				))}
			</ul>
		</section>
	);
}
